import { configureStore } from "@reduxjs/toolkit";
import createReducer from "./rootSlice";

const reducers = createReducer();

const store = configureStore({
  reducer: reducers,
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
